import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import css from "./TerAct.module.css";
import { ClinicContext } from "../../Context/ClinicContext";
import { Head } from "../../Utils/Head";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { valuesQuestionarePt } from "../../Utils/valuesQuestionare";
import { emotionHigh, emotionLow } from "../../Utils/valuedActionsPt";

export const BuildingYourPersonalJourney = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const navigate = useNavigate();
  const stepLength = 6;

  const finish = () => {
    let updatedJourney = {};
    if (userData.member) {
      updatedJourney = {
        level: 1,
        lesson: 0,
      };
    } else {
      updatedJourney = {
        level: 0,
        lesson: 5,
      };
    }

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  const handleSugestions = (temp) => {
    let list = [];

    if (temp === "emotionHigh") {
      list =
        emotionHigh[valuesQuestionarePt[userData.listValues.indexOf(5)].value];
    } else {
      list =
        emotionLow[valuesQuestionarePt[userData.listValues.indexOf(5)].value];
    }

    return list.map((t, i) => <p key={i}>{t}</p>);
  };

  return (
    <div className={css.container}>
      <Head
        title="BuildingYourPersonalJourney"
        description={"BuildingYourPersonalJourney - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div className={css.gridMainContainer}>
            <p>
              Agora que você refletiu sobre sua personalidade e identificou seus
              valores, é hora de construir uma jornada de desenvolvimento
              <span> alinhada ao que faz sentido para você.</span>
            </p>
          </div>
        )}
        {step === 1 && (
          <div className={css.gridMainContainer}>
            <h1>💬 Lembre-se:</h1>
            <p>
              Cada pessoa enfrenta dificuldades diferentes. A jornada mais
              transformadora é aquela que
              <span>
                {" "}
                respeita seu tempo, seus desafios e seu jeito de ser.
              </span>
            </p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <p>
              No próximo nível você aprenderá como manter seu crescimento
              emocional. Abaixo estão alguns temas que veremos:
            </p>
            <p>
              <span>Sofrimento e pensamentos difíceis</span>
            </p>
            <p>
              <span>Aceitação e disposição para mudar</span>
            </p>
            <p>
              <span>Autoconhecimento e presença</span>
            </p>
            <p>
              <span>Clareza de valores e ação comprometida</span>
            </p>
            <p>
              <span>Sustentação de hábitos e recaídas</span>
            </p>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <p>
              Buscando uma jornada personalizada em direção aos seus valores
              vamos começar a utilizar o diário. A tarefa será
              <span> transformar um valor em ação</span>, e programá-la para o
              dia seguinte.
            </p>
            <p>[Valor] ⇒ [Ação]</p>
          </div>
        )}
        {step === 4 && (
          <div className={css.gridMainContainer}>
            <p>
              Ao longo da sua jornada vamos sugerir ações e treinamentos
              baseados na sua personalidade e valores de vida.
            </p>
            <h1>Exemplo personalizado:</h1>
            <p>
              {valuesQuestionarePt[userData.listValues.indexOf(5)].value} +
              {" Emoção"}
              {Math.round((userData.personalityTraits[0] * 100) / 35) > 50
                ? " Alta"
                : " Baixa"}
            </p>
            <p>Sugestões:</p>
            {Math.round((userData.personalityTraits[0] * 100) / 35) > 50
              ? handleSugestions("emotionHigh")
              : handleSugestions("emotionLow")}
          </div>
        )}
        {step === 5 && (
          <div className={css.gridMainContainer}>
            <h1>
              Na aba “Diário” você encontrará as tarefas planejadas e poderá
              registrar seu humor ao realizá-las.
            </h1>
            <p>Como foi a atividade?</p>
            <p>
              <i className={`material-icons ${css.cardMoodActive}`}>mood_bad</i>
              <i className={`material-icons ${css.cardMoodActive}`}>
                sentiment_very_dissatisfied
              </i>

              <i className={`material-icons ${css.cardMoodActive}`}>
                sentiment_satisfied
              </i>
              <i className={`material-icons ${css.cardMoodActive}`}>
                sentiment_satisfied_alt
              </i>
              <i className={`material-icons ${css.cardUserIcon}`}>
                sentiment_very_satisfied
              </i>
            </p>
          </div>
        )}
        {step === 6 && (
          <div className={css.gridMainContainer}>
            <h1>Tudo pronto para começar?</h1>
            {userData.member ? (
              <p>
                Nas próximas lições, você encontrará reflexões, exercícios e
                práticas personalizadas para o seu caminho.
              </p>
            ) : (
              <>
                <p>Agende um atendimento para ter acesso a todos os recursos</p>
                <button
                  className={css.buttonContact}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send/?phone=556192492842&text=Ol%C3%A1+gostaria+de+marcar+uma+consulta&type=phone_number&app_absent=0",
                      "_blank"
                    )
                  }
                >
                  Agendar atendimento
                </button>
              </>
            )}
          </div>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
